import React, { useContext } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { numberWithCommas } from 'helper';
import * as actions from '../action';
import StructuralTypeModal from '../modals/StructuralTypeModal';

function StructuralType({
  buildingKindId,
  structuralTypeList,
  removeStructuralType,
  ordinanceRevisionId
}) {
  const setModal = useContext(ModalContext);

  const handleAddStructuralType = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <StructuralTypeModal type="NEW" buildingKindId={buildingKindId} ordinanceRevisionId={ordinanceRevisionId} />
      ),
      title: 'Add Structural Type',
      modalSize: 'modal-md',
    });
  };

  const updateStructuralType = (id, data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <StructuralTypeModal
          updateList={data.attributes}
          id={data.id}
          type="EDIT"
          buildingKindId={buildingKindId}
          ordinanceRevisionId={ordinanceRevisionId}
        />
      ),
      title: 'Update Structural Type',
      modalSize: 'modal-md',
    });
  };

  return (
    <div className="mt-1">
      <div className="row mb-3 d-flex align-items-center">
        <div className="col py-0">
          <h3 className="m-0 text-color font-weight-bold">Structural Type</h3>
        </div>
        <div className="row py-0 m-0 d-flex mr-3">
          <button
            type="button"
            onClick={handleAddStructuralType}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold px-4 mr-2 ml-auto"
          >
            <i className="fas fa-plus" /> Add Structural Type
          </button>
        </div>
      </div>
      <div className="row my-3 mx-0">
        <table className="css-table table table-sm table-striped table-hover">
          <thead className="table-header">
            <tr>
              <td width="200"><b>Type</b></td>
              <td width="200"><b>Rate</b></td>
              <td width="200"><b>Ordinance Revision</b></td>
              <td style={{ textAlign: 'center' }} width="200"><span className="font-weight-bold" style={{ marginLeft: 100 }}>Actions</span></td>
            </tr>
          </thead>
          <tbody>
            {structuralTypeList && structuralTypeList.length ? (
              structuralTypeList.map((type) => {
                return (
                  <tr key={type.id}>
                    <td className="history-color">{type.attributes.name}</td>
                    <td className="history-color">{numberWithCommas(type.attributes.unit_construction_cost)}</td>
                    <td className="history-color">{type.attributes.ordinance_revision_name}</td>
                    <td style={{ textAlign: 'right' }}>
                      <button
                        type="button"
                        className="btn-blank"
                        onClick={updateStructuralType(
                          buildingKindId,
                          type
                        )}
                      >
                        <i className="far fa-edit icon-edit" />
                      </button>
                      <button
                        type="button"
                        className="btn-blank"
                        onClick={removeStructuralType(type)}
                      >
                        <i className="far fa-trash-alt icon-delete" />
                      </button>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td />
                <td />
                <td>No Data</td>
                <td />
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
StructuralType.defaultProps = {};

StructuralType.propTypes = {
  removeStructuralType: PropTypes.instanceOf(Function).isRequired,
  // getStructuralTypeList: PropTypes.instanceOf(Function).isRequired,
  structuralTypeList: PropTypes.instanceOf(Array).isRequired,
  buildingKindId: PropTypes.string.isRequired,
  // dataInfo: PropTypes.instanceOf(Object).isRequired,
  ordinanceRevisionId: PropTypes.number.isRequired,
};

const mapStateToProps = () => ({
  // structuralTypeList:
  //   _.get(api, `${c.GET_BUILDING_STRUCTURAL_TYPE_LIST}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(StructuralType);
